<template>
  <div class="agent-permissions-item row align-middle">
    <div class="columns agent-permissions-item__info">
      <div class="agent-permissions-item__info-title">
        {{ title }}
      </div>
      <div class="agent-permissions-item__info-description">
        {{ description }}
      </div>
    </div>
    <div class="columns shrink">
      <ElSwitch :value="value" @input="emitValue" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgentPermissionsItem',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    emitValue(val) {
      this.$emit('input', val);
    },
  },
};
</script>

<style lang="scss">
.agent-permissions-item {
  // To increase specificity
  &.row {
    margin: 0;
  }

  height: rem-calc(65px);

  border-bottom: 1px solid $lb-light-gray;

  &__info {
    display: flex;
    flex-direction: column;
    padding: 0 $global-padding * 0.625;

    &-title {
      display: flex;
      align-items: center;
      font-size: rem-calc(15px);
      margin-bottom: calc($global-margin / 4);
      color: #606266;
    }

    &-description {
      font-size: rem-calc(13px);
      color: #afb0b2;
    }
  }
}
</style>
